import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed dispatch hook for Wadakaroo store
 */
export const useAppDispatch = () => useDispatch();

/**
 * Typed selector hook for Wadakaroo store
 */
export const useAppSelector = useSelector;
